import React from 'react';
import { Box, Theme, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { createStyles, makeStyles } from '@mui/styles';
import { PRIMARY_COLOR } from '../../css/theme';

const useStyles = makeStyles<Theme>(() =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      width: 'fit-content',
    },
  }),
);

type BackButtonProps = {
  onClick: () => void;
  text?: string;
};

export const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  text = 'atrás',
}) => {
  const classes = useStyles();

  return (
    <Box
      onClick={() => onClick()}
      className={classes.container}
      component="span"
    >
      <Box>
        <ArrowBackIosIcon fontSize="small" style={{ color: PRIMARY_COLOR }} />
      </Box>
      <Typography
        //textTransform="uppercase"
        color={PRIMARY_COLOR}
        variant="subtitle2"
        fontFamily={'oswald'}
        fontWeight={700}
        textTransform={'uppercase'}
      >
        {text}
      </Typography>
    </Box>
  );
};
